import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, map, merge, of, startWith, Subscription, switchMap } from 'rxjs';
import { LeadService } from 'src/app/private/services/lead.service';
import { TicketService } from 'src/app/private/services/ticket.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import {
  getLeadSourceImg as resolveLeadSourceImg,
  isLeadSourceImage,
} from 'src/app/utils/lead-source-icon.util';


@Component({
  selector: 'app-ticket-details-report',
  templateUrl: './ticket-details-report.component.html',
  styleUrls: ['./ticket-details-report.component.scss']
})
export class TicketDetailsReportComponent {
  title = "Todays Leads";
  slug: string = '';

  isLoading = false;
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100];
  isDataLoading = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  startDate: any = new Date();
  endDate: any = new Date();

  isOpen = false;

  filterLoading = false;

  selecteTodayFilter: any = "Today";

  selectedTicketStatusFilter: any[] = ["New"]

  selectedTicketPriorityFilter: any[] = ["High"]

  selectedTicketSourceFilter: any[] = ["Tina"]



  selectedLeadSource: any[] = ["Tina"]

  selectedLeadOwnership: any[] = [];

  ownerList: any[] = [];

  selectedTicketForActivity: any = {};
  hoveredTicket: any = null;
  descriptionPopupPlacement: 'left' | 'right' = 'right';
  descriptionPopupLeft = 0;
  descriptionPopupTop = 0;
  private hideDescriptionTimer: ReturnType<typeof setTimeout> | null = null;



  defaultSetting = {
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  leadWonerSetting = {
    singleSelection: false,
    idField: 'user_id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  leadStatusList: any[] = [
    "New",
    "Active",
    "Pipeline /Budgetary",
    "Contacted",
    "Qualified",
    "Converted",
    "Closed - Lost",
    "Closed - Won",
    "Follow-up",
    "Not Interested",
    "Duplicate",
    "Disqualified",
    "Marketing Qualified Lead (MQL)",
    "Sales Qualified Lead (SQL)",
  ]


  ticketStatusList: any[] = [
    "New",
    "Open",
    "In Progress",
    "On Hold",
    "Escalated",
    "Resolved",
    "Closed",
    "Cancelled",
    "Draft",
    "Reopened",
    "Deleted"
  ]

  leadSourceList: any[] = [
    "Tina",
    "WhatsApp",
    "Manual",
  ]





  displayedColumns: string[] = [
    "ticketId", "title",
    "source",
    "createdBy",
    "description", "status", "requestedAt", "updatedAt", "assignedTo", "priority",
  ];

  priorityList: any[] = [
    "High",
    "Normal",
    "Low",
    "Urgent",
  ]


  todaysFilter: any[] = [];

  initialLoad = true;
  private ticketDataSub?: Subscription;

  constructor(private route: ActivatedRoute,
    private api: TicketService,
    private localStorage: LocalStorageService,
    private userService: UsersService,
    private modalService: NgbModal
  ) { }

  // Maps each report slug to the column that the report is about, so it can be
  // surfaced immediately after the Ticket ID column.
  private readonly primaryColumnBySlug: { [slug: string]: string } = {
    'tickets-by-status': 'status',
    'tickets-by-priority': 'priority',
    'tickets-by-source': 'source',
    'tickets-assign-to': 'assignedTo',
  };

  private applyPrimaryColumnOrder(): void {
    const primaryColumn = this.primaryColumnBySlug[this.slug];
    if (!primaryColumn) {
      return;
    }
    const columns = [...this.displayedColumns];
    const primaryIndex = columns.indexOf(primaryColumn);
    if (primaryIndex === -1) {
      return;
    }
    columns.splice(primaryIndex, 1);
    const idIndex = columns.indexOf('ticketId');
    columns.splice(idIndex + 1, 0, primaryColumn);
    this.displayedColumns = columns;
  }

  ngAfterViewInit(): void {
    this.route.paramMap.subscribe(params => {
      this.slug = params.get('slug') || '';
    });

    switch (this.slug) {
      case 'tickets-by-status':
        this.title = "Tickets by Status";
        this.getTicketsByStatus();
        break;
      case 'tickets-by-priority':
        this.title = "Tickets by Priority";
        this.getTicketsByPriority();
        break;
      case 'tickets-by-source':
        this.title = "Tickets by Source";
        this.getTicketsBySource();
        break;
      case 'tickets-assign-to':
        this.title = "Tickets by User";
        this.selectedLeadOwnership = [
          {
            user_id: this.localStorage.getUserId(),
            name: `${this.localStorage.getFirstName()} ${this.localStorage.getLastName()}`
          }
        ];
        this.getTicketsByUser();
        this.getAllLeadOwners();
        break;
      case 'tickets-by-comment':
        this.title = "Tickets by Comment";
        // this.getTicketsByComment();
        break;
      default:
        this.title = "Ticket Details";
    }

    this.applyPrimaryColumnOrder();


    const today = new Date();
    const day = 24 * 60 * 60 * 1000; // one day in milliseconds
    const startOfWeek = (date: Date) => {
      const d = new Date(date);
      const diff = d.getDate() - d.getDay(); // Sunday as start of week
      return new Date(d.setDate(diff));
    };
    const endOfWeek = (date: Date) => {
      const d = startOfWeek(date);
      return new Date(d.getTime() + 6 * day);
    };
    const startOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = (date: Date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const startOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3, 1);
    const endOfQuarter = (date: Date) => new Date(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3 + 3, 0);
    const startOfYear = (date: Date) => new Date(date.getFullYear(), 0, 1);
    const endOfYear = (date: Date) => new Date(date.getFullYear(), 11, 31);

    const addDays = (date: Date, days: number) => new Date(date.getTime() + days * day);

    this.todaysFilter = [
      { label: "Today", value: "today", start_date: today, end_date: today },
      { label: "Yesterday", value: "yesterday", start_date: addDays(today, -1), end_date: addDays(today, -1) },
      { label: "Last 3 Days", value: "last_3_days", start_date: addDays(today, -2), end_date: today },
      { label: "Last 7 Days", value: "last_7_days", start_date: addDays(today, -6), end_date: today },
      { label: "Last 14 Days", value: "last_14_days", start_date: addDays(today, -13), end_date: today },
      { label: "Last 21 Days", value: "last_21_days", start_date: addDays(today, -20), end_date: today },
      { label: "Last 30 Days", value: "last_30_days", start_date: addDays(today, -29), end_date: today },
      { label: "This Week", value: "this_week", start_date: startOfWeek(today), end_date: endOfWeek(today) },
      { label: "Last Week", value: "last_week", start_date: addDays(startOfWeek(today), -7), end_date: addDays(endOfWeek(today), -7) },
      { label: "This Quarter", value: "this_quarter", start_date: startOfQuarter(today), end_date: endOfQuarter(today) },
      { label: "Last Quarter", value: "last_quarter", start_date: addDays(startOfQuarter(today), -90), end_date: addDays(startOfQuarter(today), -1) },
      { label: "This Month", value: "this_month", start_date: startOfMonth(today), end_date: endOfMonth(today) },
      { label: "Last Month", value: "last_month", start_date: new Date(today.getFullYear(), today.getMonth() - 1, 1), end_date: new Date(today.getFullYear(), today.getMonth(), 0) },
      { label: "This Year", value: "this_year", start_date: startOfYear(today), end_date: endOfYear(today) },
      { label: "Last Year", value: "last_year", start_date: new Date(today.getFullYear() - 1, 0, 1), end_date: new Date(today.getFullYear() - 1, 11, 31) },
    ];

  }

  // getTodaysLeads() {
  //   try {
  //     merge(
  //       this.paginator.page
  //     )
  //       .pipe(
  //         startWith({}),
  //         switchMap(() => {
  //           this.isDataLoading = true;

  //           let param: any = {
  //             where: { client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId() },
  //             page: this.paginator.pageIndex * this.paginator.pageSize,
  //             limit: this.paginator.pageSize,
  //             startDate: this.startDate,
  //             endDate: this.endDate,
  //             order: {
  //               order: '"leadsrecord"."updatedAt"',
  //               dir: 'DESC',
  //             },
  //           };

  //           return this.api
  //             .getAllData(param)
  //             .pipe(
  //               catchError(() => observableOf(null)));
  //         }),
  //         map((response: any) => {
  //           this.initialLoad = false;
  //           if (response === null) {
  //             return [];
  //           }
  //           this.totalRows = response.count;
  //           return response;
  //         })
  //       )
  //       .subscribe({
  //         next: (data) => {

  //           this.dataSource = new MatTableDataSource<any>(data.rows);

  //           this.isDataLoading = false;
  //         },
  //         error: (e) => {

  //           this.isDataLoading = false;
  //           console.error(e);
  //         },
  //         complete: () => { },
  //       });
  //   } catch (e) {
  //     console.error(e);
  //   }
  // }

  getTicketsByStatus() {
    try {
      this.ticketDataSub?.unsubscribe();
      this.ticketDataSub = merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              where: {
                client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId(),
                ticket_status: this.selectedTicketStatusFilter,
              },
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                col: '"manage_ticket"."createdAt"',
                dir: 'DESC',
              },
            };

            return this.api
              .getAllTinaTicket(param)
              .pipe(
                catchError(() => of(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            this.initialLoad = false;

            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }

  getTicketsByPriority() {
    try {
      this.ticketDataSub?.unsubscribe();
      this.ticketDataSub = merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              where: {
                client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId(),
                priority: this.selectedTicketPriorityFilter,
              },
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                col: '"manage_ticket"."createdAt"',
                dir: 'DESC',
              },
            };

            return this.api
              .getAllTinaTicket(param)
              .pipe(
                catchError(() => of(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            this.initialLoad = false;

            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }


  getTicketsBySource() {
    try {
      this.ticketDataSub?.unsubscribe();
      this.ticketDataSub = merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              where: {
                client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId(),
                source: this.selectedTicketSourceFilter,
              },
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                col: '"manage_ticket"."createdAt"',
                dir: 'DESC',
              },
            };

            return this.api
              .getAllTinaTicket(param)
              .pipe(
                catchError(() => of(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            this.initialLoad = false;

            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }


  getTicketsByUser() {
    try {
      this.ticketDataSub?.unsubscribe();
      this.ticketDataSub = merge(
        this.paginator.page
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.isDataLoading = true;

            let param: any = {
              where: {
                client_id: this.localStorage.getClientId(), center_id: this.localStorage.getCenterId(),
                assign_to: this.selectedLeadOwnership?.map((owner: any) => owner.user_id) || [],
              },
              page: this.paginator.pageIndex * this.paginator.pageSize,
              limit: this.paginator.pageSize,
              order: {
                col: '"manage_ticket"."createdAt"',
                dir: 'DESC',
              },
            };

            return this.api
              .getAllTinaTicket(param)
              .pipe(
                catchError(() => of(null)));
          }),
          map((response: any) => {
            this.initialLoad = false;
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            return response;
          })
        )
        .subscribe({
          next: (data) => {

            this.dataSource = new MatTableDataSource<any>(data.rows);

            this.isDataLoading = false;
          },
          error: (e) => {

            this.isDataLoading = false;
            this.initialLoad = false;

            console.error(e);
          },
          complete: () => { },
        });
    } catch (e) {
      console.error(e);
    }
  }


  getAllLeadOwners() {
    try {

      let param = {
        client_id: this.localStorage.getClientId(),
      };

      this.userService.findAllUsers(param).subscribe({
        next: (data) => {
          this.ownerList = data;

          this.ownerList = this.ownerList.map((owner: any) => {
            return {
              user_id: owner.user_id,
              name: `${owner.fname} ${owner.lname}`,
            };
          });
        },
        error: (e) => {
          console.error(e);
        },
        complete: () => { },
      });
    } catch (e) {
      console.error(e);
    }
  }




  onTodaysFilterChange(event: any) {
    let selectedFilter = this.todaysFilter.find((filter) => filter.label === event);
    console.log(selectedFilter);
    this.startDate = selectedFilter.start_date;
    this.endDate = selectedFilter.end_date;
  }

  onFilterChange(event: any) {
    // this.selecteLeadStatusFilter = event;
    this.onTodaysFilterChange(this.selecteTodayFilter);
  }



  isSourceImage(source: string) {
    return isLeadSourceImage(source);
  }

  getLeadSourceImg(source: string) {
    return resolveLeadSourceImg(source);
  }

  openBulkFilter() {
    this.isOpen = true;
  }

  closeSidebar() {
    this.isOpen = false;
  }

  applyBulkFilter() {
    this.isOpen = false;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    if (this.slug == 'tickets-by-status') {
      this.getTicketsByStatus();
    } else if (this.slug == 'tickets-by-priority') {
      this.getTicketsByPriority();
    } else if (this.slug == 'tickets-by-source') {
      this.getTicketsBySource();
    }
    else if (this.slug == 'tickets-assign-to') {
      this.getTicketsByUser();
    }
    else if (this.slug == 'tickets-by-comment') {
      // this.getTicketsByComment();
    }
    else {
      this.getTicketsByStatus();
    }
  }
  clearFilter() {
    this.isOpen = false;
  }

  getOwnerName(owner: any) {
    if (owner && owner.fname && owner.lname) {
      return `${owner.fname} ${owner.lname}`;
    } else if (owner && owner.fname) {
      return owner.fname;
    } else if (owner && owner.lname) {
      return owner.lname;
    } else {
      return 'N/A';
    }
  }

  showTicketDescription(ticket: any, event: MouseEvent): void {
    this.cancelHideTicketDescription();
    this.hoveredTicket = ticket;
    this.updateDescriptionPopupPlacement(event);
  }

  scheduleHideTicketDescription(): void {
    this.cancelHideTicketDescription();
    this.hideDescriptionTimer = setTimeout(() => this.hideTicketDescription(), 150);
  }

  cancelHideTicketDescription(): void {
    if (this.hideDescriptionTimer) {
      clearTimeout(this.hideDescriptionTimer);
      this.hideDescriptionTimer = null;
    }
  }

  hideTicketDescription(): void {
    this.cancelHideTicketDescription();
    this.hoveredTicket = null;
  }

  private updateDescriptionPopupPlacement(event: MouseEvent): void {
    const anchor = event.currentTarget as HTMLElement;
    const rect = anchor.getBoundingClientRect();
    const popupWidth = 360;
    const gap = 6;
    const placeLeft = rect.right + gap + popupWidth > window.innerWidth - 8;
    this.descriptionPopupPlacement = placeLeft ? 'left' : 'right';
    this.descriptionPopupLeft = placeLeft ? rect.left - popupWidth - gap : rect.right + gap;
    this.descriptionPopupTop = Math.max(8, Math.min(rect.top, window.innerHeight - 280));
  }


  isImage(file: string): boolean {
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
  }

  // Check if the file is a video
  isVideo(file: string): boolean {
    return /\.(mp4|webm|ogg|mov)$/i.test(file);
  }

  // Get file name from the URL (optional, for display)
  getFileName(file: string): string {
    return file.split('/').pop() || 'Unknown File';
  }


  isPDF(file: string): boolean {
    return /\.(pdf)$/i.test(file);
  }
}

